"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomItemContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ItemContainerBase_1 = require("../ItemContainerBase");
var DomItemContainer = /** @class */ (function (_super) {
    __extends(DomItemContainer, _super);
    function DomItemContainer() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this._ref = function (el) {
            _this._element = el;
            _this._updateElement();
        };
        return _this;
    }
    DomItemContainer.prototype._updateElement = function () {
        if (!this._element) {
            return;
        }
        this._element.style.position = "absolute";
        this._element.style.height = this.props.layoutRect.height + "px";
        this._element.style.width = this.props.layoutRect.width + "px";
        this._element.style.transform = "translate3d(".concat(this.props.layoutRect.x, "px, ").concat(this.props.layoutRect.y, "px, 0px)");
    };
    DomItemContainer.prototype.componentDidUpdate = function () {
        this._updateElement();
    };
    DomItemContainer.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)("div", { ref: this._ref, children: this.renderItem() });
    };
    return DomItemContainer;
}(ItemContainerBase_1.ItemContainerBase));
exports.DomItemContainer = DomItemContainer;
//# sourceMappingURL=DomItemContainer.js.map